export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/dashboard/Dashboard'),
    props: true,
    meta: {
      requiresAuth: true
    }
  }
]
